var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlobHamburger = function SvgBlobHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 74 63"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2E9DD",
    d: "M73.083 32.847c-.575 16.449-19.563 30.552-35.96 29.98C20.723 62.255.262 53.96.837 37.514 1.414 21.048 25.268.376 41.668.948c16.808.586 31.99 15.452 31.415 31.9"
  })));
};
export default SvgBlobHamburger;